import { render, staticRenderFns } from "./nursingBalanceDetail.vue?vue&type=template&id=df564674&scoped=true&"
import script from "./nursingBalanceDetail.vue?vue&type=script&lang=js&"
export * from "./nursingBalanceDetail.vue?vue&type=script&lang=js&"
import style0 from "./nursingBalanceDetail.vue?vue&type=style&index=0&id=df564674&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df564674",
  null
  
)

export default component.exports